import { render, staticRenderFns } from "./Magnifier.vue?vue&type=template&id=a7d1893c"
import script from "./Magnifier.vue?vue&type=script&lang=js"
export * from "./Magnifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports